import React from 'react';
import { Link, Outlet, useLocation, matchPath } from 'react-router-dom';
import Footer from './Footer';
import './Header.css';

function AppLayout() {
  const location = useLocation();
  const hideHeader = Boolean(matchPath('/profile/:username', location.pathname));

  return (
    <div className="app-container">
      {!hideHeader && (
        <header className="header">
          <div className="header-left">
            <Link className="header-brand-link" to="/">
              <h1>Ladyfirst.me</h1>
              <p className="subtitle">Pre-loved fashion, made for women</p>
            </Link>
          </div>
          <nav className="public-nav" aria-label="Main navigation">
            <Link to="/">Home</Link>
            <Link to="/support">Support</Link>
          </nav>
        </header>
      )}
      <main>
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}

export default AppLayout;
